import React from "react";
import { Box, Typography, Card, CardContent, Grid } from "@mui/material";
import { Assessment as AnalyticsIcon } from "@mui/icons-material";
import { motion } from "framer-motion";

const Analytics = () => {
  return (
    <Box>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            Analytics & Reports
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Comprehensive business analytics and insights
          </Typography>
        </Box>
        <Card>
          <CardContent>
            <Typography variant="body1" sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
              Analytics dashboard with revenue trends, conversion rates, churn analysis, and more coming soon...
            </Typography>
          </CardContent>
        </Card>
      </motion.div>
    </Box>
  );
};

export default Analytics;

